import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { CountricsPageRoutingModule } from './countrics-routing.module';

import { CountricsPage } from './countrics.page';
import {ComponentsModule} from "../../shared/components/components.module";
import {SharedModule} from "../../shared/shared.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        CountricsPageRoutingModule,
        ComponentsModule,
        SharedModule
    ],
  declarations: [CountricsPage]
})
export class CountricsPageModule {}
